import * as React from 'react'
import styled from 'styled-components'
import colors from '../../globals/colors'
import Backgorund from '../../assets/background/dashboard-gradient-box-background.svg';
import PieChart from './PieChart';
import LineChart from './LineChart';
import { InvestmentSharedByProject, InvestmentWithProjectTitle } from '../../shared/UI';
import { lang, translateContent } from '../../globals/Translations';
import { NiceDate, NiceIntrestRate, NiceNumberWithCurrency } from '../../shared/UIFormatting';
import { calculateInvestmentProjectPaidBackAmount, IsInvestmentLeagallyBinding } from '../../shared/BusinessIntelligence';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { RowFlexBox } from '../templates/Wrappers';
import { ACTION_TRANSLATION_SUFFIX } from '../../assets/translations/InvestmentStepsDictionary';
import { IsHorizontalMobile, IsMobile, RETURN_TO_DASHBAORD_QUERY, useWindowSize } from '../../globals/UIHooks';
import { DefaultId } from '../../shared/Globals';
import { ToolTip } from '../atoms/Inputs';
import { useHistory } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { deleteInvestment } from '../../globals/ApiHooks';
import { Loading } from './Loading';
import Project from '../../shared/Project';
import { UINotification } from '../../shared/Notifications';
import { ProjectStatus, ProjectStatusLabel } from '../../shared/ProjectStatus';

export const DefaultLatestNews = {
    title: {
        [DefaultId]: "New permit from the Financial Authority",
        "da": "Ny tilladelse fra Finanstilsynet"
    },
    subTitle: {
        [DefaultId]: "We will ask for some additional information the next time you make an investment.",
        "da": "Vi kommer til at spørge om nogle ekstra oplysninger næste gang du laver en investering."
    },
}

export const DASHBOARD_GAP = 20

type DefaultProps = {
    loading: boolean,
}


export const BackgorundDashboardBox = styled.div`
    display: flex;
    width: 100%;
    box-shadow: ${colors.defaultShadow};
    background-color: ${colors.primaryOpacity};
    border-radius: 10px;
    padding: 20px;
`
export const BoxTemplate = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    box-shadow: ${colors.defaultShadow};
    background-color: ${colors.primaryOpacity};
    border-radius: 10px;
    padding: 20px;
`

export const NewsBox: React.FC = () => {
    const [timeLeft, setTimeLeft] = React.useState(5);

    React.useEffect(() => {
        if (timeLeft === 0) return;
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    return (
        <BoxTemplate style={{
            backgroundImage: `url(${Backgorund})`, backgroundSize: 'cover',
        }}>
            <div style={{
                display: 'flex', flexDirection: 'column', justifyContent: 'end', height: '100%', width: '100%',
                backgroundPosition: 'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'
            }}>
                <h5 style={{ color: colors.lightest }}>{translateContent(DefaultLatestNews.title)}</h5>
                <span style={{ color: colors.light }}>{translateContent(DefaultLatestNews.subTitle)}</span>
            </div>
        </BoxTemplate>
    )
}

const TextBox = styled.div`
    display: flex;
    flex-direction: column;
`


export const SmallInvestmentBox: React.FC<{ item?: InvestmentWithProjectTitle }> = ({ item }) => {

    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
            <TextBox>
                <span>{item && translateContent(item.projectTitle)}</span>
                <span className="light">{item && NiceDate(item.investment.investmentTerms.created)}</span>
            </TextBox>
            <TextBox style={{ textAlign: 'right' }}>
                <span>{item && NiceNumberWithCurrency(item.investment.amount)}</span>
                <span className="light">{item && lang(item.investment.step)}</span>
            </TextBox>
        </div>
    )
}

export const InvestmentPieChart: React.FC<DefaultProps & { data?: InvestmentSharedByProject[] }> = ({ data, loading }) => {

    return (
        <BoxTemplate>
            <PieChart data={data} loading={loading} />
        </BoxTemplate>
    )
}

export const InvestmentReturnChart: React.FC = () => {

    return (
        <BoxTemplate>
            <LineChart />
        </BoxTemplate>
    )
}

const Head = styled.td`
    text-align: left;
    padding: 8px;
    font-weight: 700;
`

const Cell = styled.td`
    border-top: 1px solid #dddddd;
    text-align: left;
    padding: 4px;
    font-weight: 400;
`
const CellSmall = styled.td`
    border-top: 1px solid #dddddd;
    text-align: left;
    padding: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.1;
    color: ${colors.grayText};
`
const Row = styled.tr`
    :hover{
        cursor: pointer;
    }
`

const ProjectRow: React.FC<{ item: InvestmentWithProjectTitle, horizontalMobile: boolean, mobile: boolean, showActualReturn?: boolean, project?: Project }> = ({ item, mobile, horizontalMobile, showActualReturn, project }) => {
    const history = useHistory()
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [deleted, setDeleted] = React.useState(false)

    const [isDeletenig, setIsDeletenig] = React.useState(false)

    const handleDelete = async () => {
        if (!isDeletenig) return setIsDeletenig(true)
        setLoading(true)
        await deleteInvestment(item.investment.investmentId)
        setDeleted(true)
        setLoading(false)
    }

    const handleClick = () => {
        history.push("/investment/" + item.investment.investmentId + '?' + RETURN_TO_DASHBAORD_QUERY)
    }

    const completed = IsInvestmentLeagallyBinding(item.investment)

    const startDate = project?.state.interestStartDate
    const endDate = project?.state.interestEndDate
    const duration = project?.finance.durationMin + "- " + project?.finance.durationMax + " " + lang(TranslatedTerms.MTH)

    const projectWithLoss = item.projectStatus === ProjectStatus.FAILED
    const isProjectInFailProcess = item.projectStatus === ProjectStatus.FAILD_PROCESS


    if (loading) return <Loading />

    if (deleted) return <></>

    if (projectWithLoss) {
        const paidBackAmount = project && calculateInvestmentProjectPaidBackAmount(project, item.investment)
        return (
        <Row onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} style={open ? { backgroundColor: colors.primaryOpacity } : {}}>
            <Cell onClick={handleClick}>{translateContent(item.projectTitle)}  ({NiceIntrestRate(item.investment.investmentTerms.interestRate, true)})</Cell>
            {!mobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{paidBackAmount !== undefined && NiceNumberWithCurrency(paidBackAmount) || lang(TranslatedTerms.UNKNOWN)}</Cell>}
            {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}></Cell>}
            {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}></Cell>}
            {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}></Cell>}
            {!mobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{NiceNumberWithCurrency(item.investment.amount)}</Cell>}
            <Cell onClick={handleClick} style={{ textAlign: 'right' }}>
                <button style={{ width: '100%', fontSize: 12, fontWeight: 400, backgroundColor: colors.danger, padding: "6px 2px" }}>
                    {lang(ProjectStatusLabel.PROJECT_FAILED)}
                </button>
            </Cell>
        </Row>
    )}

    if (isProjectInFailProcess) return (
        <Row onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} style={open ? { backgroundColor: colors.primaryOpacity } : {}}>
            <Cell onClick={handleClick}>{translateContent(item.projectTitle)}  ({NiceIntrestRate(item.investment.investmentTerms.interestRate, true)})</Cell>
            {!mobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{NiceNumberWithCurrency(showActualReturn ? item.possibleReturns.actual : item.possibleReturns.avg)}</Cell>}
            {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{startDate ? NiceDate(startDate) : lang(TranslatedTerms.UNKNOWN)}</Cell>}
            {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}></Cell>}
            {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}></Cell>}
            {!mobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{NiceNumberWithCurrency(item.investment.amount)}</Cell>}
            <Cell onClick={handleClick} style={{ textAlign: 'right' }}>
                <button style={{ width: '100%', fontSize: 12, fontWeight: 400, backgroundColor: colors.danger, padding: "6px 2px" }}>
                    {lang(ProjectStatusLabel.PROJECT_FAIL_IN_PROCESS)}
                </button>
            </Cell>
        </Row>
    )

    return (
        <>
            <Row onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} style={open ? { backgroundColor: colors.primaryOpacity } : {}}>
                <Cell onClick={handleClick}>{translateContent(item.projectTitle)}  ({NiceIntrestRate(item.investment.investmentTerms.interestRate, true)})</Cell>
                {!mobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{NiceNumberWithCurrency(showActualReturn ? (item.possibleReturns.actual+item.investment.amount) : item.possibleReturns.avg)}</Cell>}
                {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{startDate ? NiceDate(startDate) : lang(TranslatedTerms.UNKNOWN)}</Cell>}
                {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{endDate ? NiceDate(endDate) : lang(TranslatedTerms.UNKNOWN)}</Cell>}
                {!horizontalMobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{duration}</Cell>}
                {!mobile && <Cell onClick={handleClick} style={{ textAlign: 'right' }}>{NiceNumberWithCurrency(item.investment.amount)}</Cell>}
                <Cell onClick={handleClick} style={{ textAlign: 'right' }}>
                    <button style={{ width: '100%', fontSize: 12, fontWeight: 400, backgroundColor: completed ? colors.sucess : colors.primary, padding: "6px 2px" }}>
                        {lang(item.investment.step + ACTION_TRANSLATION_SUFFIX)}
                    </button>
                </Cell>
                <Cell>
                    {!completed && !isDeletenig && (
                        <button className='light' style={{ padding: "6px 8px", backgroundColor: colors.danger }} onClick={handleDelete}>
                            <CloseIcon style={{ color: colors.lightest }} />
                        </button>
                    )}

                    {!completed && isDeletenig && (
                        <RowFlexBox style={{ alignItems: 'center' }}>
                            <span style={{ marginRight: 10 }}>{lang(TranslatedTerms.ARE_YOU_SURE)}?</span>
                            <button className='light' style={{ marginLeft: 4, marginRight: 4, backgroundColor: colors.danger, color: colors.lightest }}
                                onClick={handleDelete}>
                                {lang(TranslatedTerms.DELETE)}
                            </button>
                            <button className='light' style={{ marginLeft: 4, marginRight: 4 }} onClick={() => setIsDeletenig(false)}>
                                {lang(TranslatedTerms.CANCEL)}
                            </button>
                        </RowFlexBox>
                    )}
                </Cell>
            </Row>
            {mobile &&
                <Row onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} style={open ? { backgroundColor: colors.primaryOpacity } : {}}>
                    <Cell onClick={handleClick} style={{ textAlign: 'right', borderTopWidth: 0 }}>
                        {lang(TranslatedTerms.INVESTMENT)}: {NiceNumberWithCurrency(item.investment.amount)}
                    </Cell>
                    <Cell onClick={handleClick} style={{ textAlign: 'right', borderTopWidth: 0 }}>
                    </Cell>
                </Row>
            }
            {mobile &&
                <Row onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} style={open ? { backgroundColor: colors.primaryOpacity } : {}}>
                    <Cell onClick={handleClick} style={{ textAlign: 'right', borderTopWidth: 0 }}>
                        {showActualReturn ? lang(TranslatedTerms.INTREST_REVENUE) : lang(TranslatedTerms.EXPECTED_RETURN)}: {NiceNumberWithCurrency(showActualReturn ? item.possibleReturns.actual : item.possibleReturns.avg)}
                    </Cell>
                    <Cell onClick={handleClick} style={{ textAlign: 'right', borderTopWidth: 0 }}>
                    </Cell>
                </Row>
            }
        </>
    )
}

type InvestmentTableProps = DefaultProps & { investments: InvestmentWithProjectTitle[], accountValue: number, showActualReturn?: boolean, projects: Project[] }

export const InvestementsTable: React.FC<InvestmentTableProps> = ({ investments, loading, showActualReturn, projects }) => {

    const horizontalMobile = IsHorizontalMobile(useWindowSize().width)
    const mobile = IsMobile(useWindowSize().width)

    const getProject = (projectId: string) => {
        if (!projects) return
        return projects.find((i) => i.projectId === projectId)
    }

    return (
        <>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, lineHeight: 1.3 }}>
                <thead>
                    <tr>
                        <Head>{lang(TranslatedTerms.PROJECT)}</Head>
                        {!mobile && <Head style={{ display: 'flex', justifyContent: 'right' }}>{showActualReturn ? lang(TranslatedTerms.PAID_BACK) : lang(TranslatedTerms.EXPECTED_RETURN)}{!showActualReturn && <ToolTip content={lang(TranslatedTerms.INTEREST_CALCULATED_BASED_ON_AVAGE_MONTHS)} />}</Head>}
                        {!horizontalMobile && <Head style={{ textAlign: 'right' }}>{lang(TranslatedTerms.PROJECT_START)}</Head>}
                        {!horizontalMobile && <Head style={{ textAlign: 'right' }}>{lang(TranslatedTerms.PROJECT_END)}</Head>}
                        {!horizontalMobile && <Head style={{ textAlign: 'right' }}>{lang(TranslatedTerms.DURATION)}</Head>}
                        {!mobile && <Head style={{ textAlign: 'right' }}>{lang(TranslatedTerms.INVESTMENT)}</Head>}
                        <Head style={{ textAlign: 'right' }}>{lang(TranslatedTerms.STATUS)}</Head>
                    </tr>
                </thead>
                <tbody>
                    {investments && investments.map((item, key) => <ProjectRow showActualReturn={showActualReturn} key={key} horizontalMobile={horizontalMobile} mobile={mobile} item={item} project={getProject(item.investment.projectId)} />)}
                </tbody>
            </table>
            <RowFlexBox style={{ justifyContent: 'center' }}>{!loading && investments && investments.length === 0 && <span>{lang(TranslatedTerms.NO_INVESTMENTS)}</span>}</RowFlexBox>
        </>
    )
}


export const NotificationTable: React.FC<DefaultProps & { notifications?: UINotification[] }> = ({ notifications, loading }) => {
    const pageSize = 5
    const onlyOnePage = notifications && notifications.length <= pageSize
    const [page, setPage] = React.useState<number>(0)
    const [rows, setRows] = React.useState<UINotification[]>()
    const mobile = IsMobile(useWindowSize().width)

    React.useEffect(() => {
        if (notifications) setRows(notifications)
    }, [notifications])

    const getRow = (item: UINotification, key: number) => {
        const max = page * pageSize + pageSize
        const min = page * pageSize
        if (key >= max || key < min) return;

        if (mobile) return (
            <Row key={key}>
                <CellSmall style={{ fontSize: 12 }}>{item.title} - {NiceDate(item.created)}</CellSmall>
            </Row>
        )
        return (
            <Row key={key}>
                <CellSmall style={{ fontSize: 12 }}>{item.title}</CellSmall>
                <CellSmall style={{ textAlign: 'right' }}>{NiceDate(item.created)}</CellSmall>
            </Row>
        )
    }

    const totalPageNumer = onlyOnePage ? 1 : Math.floor(((notifications || []).length + 1) / pageSize)

    return (
        <div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <Head style={{ padding: 4 }}>{lang(TranslatedTerms.NOTIFICATIONS)}</Head>
                        {!mobile && <Head style={{ padding: 4, minWidth: 140, textAlign: 'right' }}>{lang(TranslatedTerms.DATE)}</Head>}
                    </tr>
                </thead>
                <tbody>
                    {rows && rows.map(getRow)}
                </tbody>
            </table>
            <RowFlexBox style={{ justifyContent: 'center' }}>{!loading && rows && rows.length === 0 && <span>{lang(TranslatedTerms.NO_ACTIVITY)}</span>}</RowFlexBox>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <button
                    onClick={() => page > 0 && setPage(page - 1)}
                    className={page === 0 ? "smallDisable" : "small"}
                    style={{ width: 100, marginLeft: 6, marginRight: 6 }}>
                    {lang(TranslatedTerms.BACK)}
                </button>
                <button
                    onClick={() => page < totalPageNumer - 1 && setPage(page + 1)}
                    className={page === totalPageNumer - 1 || onlyOnePage ? "smallDisable" : "small"}
                    style={{ width: 100, marginLeft: 6, marginRight: 6 }}>
                    {lang(TranslatedTerms.NEXT)}
                </button>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <span className="light">Page {page + 1} of {totalPageNumer}</span>
            </div>
        </div>

    )
}


type AccountBoxProps = {
    lastInvestment?: InvestmentWithProjectTitle,
    userAccountsValue?: number,
    userCurrency?: number
}

export const AccountBox: React.FC<DefaultProps & AccountBoxProps> = ({ loading, lastInvestment, userAccountsValue }) => {

    const incative = !lastInvestment || !userAccountsValue || userAccountsValue === 0
    if (!loading && incative) return (
        <BoxTemplate style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <h5>{lang(TranslatedTerms.WELCOME_TO_FUNDBRICKS)}</h5>
            <p className="small">{lang(TranslatedTerms.DASHBOARD_DESCRIPTION)}</p>
        </BoxTemplate>

    )

    return (
        <BoxTemplate style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <div style={{ display: 'flex', }}>
                    <span style={{ margin: 0, fontWeight: 700, paddingRight: 4, fontSize: 19 }}>{userAccountsValue && NiceNumberWithCurrency(userAccountsValue)}</span>
                </div>
                <span className="light">{userAccountsValue && lang(TranslatedTerms.ACCOUNT_VALUE) + " - " + lang(TranslatedTerms.ALL_ACCOUNTS)}</span>
                {lastInvestment && <a href="/projects"><button className="small">{lang(TranslatedTerms.INVEST)}</button></a>}
                <span style={{ marginTop: 8 }} className="light">{lastInvestment && lang(TranslatedTerms.LATEST_INVESTMENT)}</span>
            </div>
            <SmallInvestmentBox item={lastInvestment} />
        </BoxTemplate>
    )
}
